// extracted by mini-css-extract-plugin
export const defaultPreloader = "DefaultPreloader__defaultPreloader__Q6jzu";